import './UsersPanel.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { KeyPagination } from '@ui/KeyPagination';
import { SonarTable } from '@ui/SonarTable';
import { UserTableSearch } from './UserTableSearch';
import { getUserTableColumns, getUserTableRowKey } from './UsersTableColumns';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useAction, useSonarSelector } from '@hooks';
const getCustomerUsersSelectors = createAsyncSelectors((state) => state.core.customers.byId.users.get);
export const UsersTable = ({ defaultPageSize = 20, id, searchDetails }) => {
    const [emailFilter, setEmailFilter] = useState('');
    const customerUsers = useSonarSelector(getCustomerUsersSelectors.data);
    const getCustomerUsers = useAction(coreActions.requestGetCoreCustomersByIdUsers);
    const handleEmailFilterChanged = useCallback((value) => {
        setEmailFilter(value);
    }, []);
    const getCustomerUsersPage = useCallback((count = defaultPageSize, paginationDirection = PaginationDirection.Forward, key) => {
        if (searchDetails) {
            const { customerId, shardName } = searchDetails;
            getCustomerUsers({
                count: count !== null && count !== void 0 ? count : defaultPageSize,
                customerId,
                filter: emailFilter,
                key,
                paginationDirection,
                shardName
            });
        }
    }, [defaultPageSize, searchDetails, getCustomerUsers, emailFilter]);
    const handlePaginationChanged = useCallback((pagination) => {
        var _a;
        if (customerUsers) {
            const paginationDirection = (_a = pagination.paginationDirection) !== null && _a !== void 0 ? _a : PaginationDirection.Forward;
            const key = pagination.paginationDirection === PaginationDirection.Forward ?
                customerUsers === null || customerUsers === void 0 ? void 0 : customerUsers.nextKey :
                customerUsers === null || customerUsers === void 0 ? void 0 : customerUsers.prevKey;
            getCustomerUsersPage(pagination.count, paginationDirection, key);
        }
    }, [getCustomerUsersPage, customerUsers]);
    useEffect(() => {
        getCustomerUsersPage();
    }, [getCustomerUsersPage]);
    useEffect(() => {
        var _a;
        setEmailFilter((_a = searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.userEmail) !== null && _a !== void 0 ? _a : '');
    }, [searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.userEmail]);
    const tableColumns = useMemo(() => getUserTableColumns(searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.shardName), [searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.shardName]);
    return (React.createElement("div", { className: 'admin-users-table' },
        React.createElement(UserTableSearch, { onSearch: handleEmailFilterChanged, value: emailFilter }),
        React.createElement(SonarTable, { columns: tableColumns, dataSource: customerUsers === null || customerUsers === void 0 ? void 0 : customerUsers.results, id: id, pagination: false, rowKey: (record) => getUserTableRowKey(record, searchDetails === null || searchDetails === void 0 ? void 0 : searchDetails.shardName) }),
        React.createElement(KeyPagination, { autoHide: true, defaultPageSize: defaultPageSize, onChange: handlePaginationChanged, resource: customerUsers })));
};
